import { CustomFieldGroup } from './custom-field-group.model';
import { CustomFieldCondition } from './custom-field-condition.model';
import { ModuleScope } from './module-assignment.model';

export class CustomFieldSchema {
  module: ModuleScope;
  groups: CustomFieldGroup[];
  conditions: CustomFieldCondition[];

  constructor() {
    this.module = null;
    this.groups = [];
    this.conditions = [];
  }
}
